export enum ClientRegistrationPageModeEnum {
    Default = 'Default',
    HaveProperty = 'HaveProperty',
    SuccessfulRegistration = 'SuccessfulRegistration',
    Error = 'Error',
    EmailAlreadyExists = 'EmailAlreadyExists',
    AgentDisabled = 'AgentDisabled'
}

export enum BlurredImgEnum {
    buy_home_details = 'buy_home_details',
    buy_loan_options = 'buy_loan_options',
    own_home_value = 'own_home_value',
    own_loan_balance = 'own_loan_balance',
    own_payments = 'own_payments'
}

export enum EmailCampaignDialogMode {
    Initial = 'initial',
    Resend = 'resend',
    CheckEmailStatus = 'checkEmailStatus',
    Confirmation = 'confirmation'
}

export enum BusinessTypeId {
    'Mortgage Lender' = 'B053507B-328F-EA11-86E9-000D3A328C22',
    'Real Estate' = '00C412CB-328F-EA11-86E9-000D3A328C22'
}

export enum BusinessTypeName {
    MortgageLender = 'Mortgage Lender',
    RealEstate = 'Real Estate'
}

export enum RFM {
    Code = 'RFM'
}
